import React from 'react';
import styled from '@emotion/styled';

interface ComponentHeaderProps {
  text: string;
  description?: string;
  align?: 'left' | 'center' | 'right';
}

const ComponentHeader: React.FC<ComponentHeaderProps> = ({ text, description, align = 'center' }) => {
  return <StyledHeader align={align}><h3>{text}</h3><p>{description}</p></StyledHeader>;
};

export default ComponentHeader;

const StyledHeader = styled.div<{ align: 'left' | 'center' | 'right' }>`
  width: 100%;
  font-weight: 800;
  font-size: 40px;
  text-align: ${({ align }) => align};

  @media (max-width: 884px) {
    font-size: 30px;
    line-height: 36.4px;
  }

  h3{
    width: 100%;
    text-align: ${({ align }) => align};
  }

  p {
    padding-top: 10px;
    width: 100%;
    text-align: ${({ align }) => align};
    color: #000000;
    margin: 0;
    font-weight: 400;
    font-style: Regular;
    font-size: 20px;
    leading-trim: NONE;
    line-height: 100%;
    letter-spacing: 0px;
}
`;
